export const EXPLORE_GOUSTO = {
  headingLine1: 'Explore the Gousto menu: Fresh recipes for every taste',
  altText: 'A big bowl of chicken salad with quinoa, vegetables, shaved cheese, herbs and seeds.',
}
